import * as React from 'react'
import styled, { css } from 'styled-components';
import Icon, { IconTypes } from '../Icons/Icon';
import { Style } from '../../styles';
import { IncomingSelfBillingOrder, IncomingSelfBillingOrderStatus, LedgerItemStatus } from '../../types';
import { useTranslation } from 'react-i18next';
import IncomingSelfBillingOrderHelper from '../../helpers/IncomingSelfBillingOrderHelper';
import SimpleTooltip from '@/components/Tooltips/SimpleTooltip'

interface IProps {
	order?: IncomingSelfBillingOrder
	rounded?: boolean
	width?: number
	onClick: () => void
}

interface ContainerProps {
	rounded?: boolean
	width: number
	backgroundColor: string
	onClick?: () => void
}

const Container = styled.div`
	position: relative;
	overflow: visible;
	display: flex;
	justify-content: center;
	align-items: center;
	${(props: ContainerProps) => css`
		width: ${props.width}px;
		height: ${props.width}px;
		background-color: ${props.backgroundColor};
		color: white;
		fill: white;
	`}
	border: 2px solid transparent;
	transition: border-color .3s;
	border-radius: 7px;
	overflow: hidden;

	${(props: ContainerProps) => props.rounded && css`
		border-radius: 50%;
	`}

	${(props: ContainerProps) => props.onClick && css`
		cursor: pointer;
	`}

	svg {
		width: 15px;
	}
`

const StyledIcon = styled(Icon)`
	color: white;
	fill: white;
`

const IncomingSelfBillingOrderAvatar = (props: IProps) => {
	const { t } = useTranslation()
	const { order, rounded, width, onClick } = props

	let backgroundColor = '#ccc'
	let icon: IconTypes = 'question-mark'

	const status = IncomingSelfBillingOrderHelper.getStatus(order)
	const statusLabel = IncomingSelfBillingOrderHelper.getStatusLabel(status)

	switch (status) {
		case IncomingSelfBillingOrderStatus.OVERDUE:
			backgroundColor = Style.color.brandDanger
			icon = 'exclamation-triangle'
			break
		case IncomingSelfBillingOrderStatus.OUTSTANDING:
			backgroundColor = Style.color.brandWarning
			icon = 'hourglass-half'
			break
		case IncomingSelfBillingOrderStatus.PAID:
		case IncomingSelfBillingOrderStatus.CREDITED:
			backgroundColor = Style.color.brandSuccess
			icon = 'check'
			break
		case IncomingSelfBillingOrderStatus.CREDITED:
			backgroundColor = Style.color.brandSuccess
			icon = 'check'
			break
	}

	return (
		<SimpleTooltip content={statusLabel}>
			<Container
				rounded={rounded}
				width={width || 40}
				backgroundColor={backgroundColor}
				onClick={onClick}
			>
				<StyledIcon icon={icon} />
			</Container>
		</SimpleTooltip>
	)
}

export default IncomingSelfBillingOrderAvatar